import { createSlice } from "@reduxjs/toolkit";
import { dropdownInitialState } from "src/models/drop_down/dropdown.dto";
import { fetchDropdownProductThunk, fetchDropdownThunk, fetchDropdownWarehouseThunk } from "../action/dropdown.action";

export const dropdownSlice = createSlice({
    name: 'dropdown',
    initialState:dropdownInitialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchDropdownThunk.pending, (state) => {
          state.loading = true;
          state.error = false;
          state.errorMessage = null;
        })
        .addCase(fetchDropdownThunk.fulfilled, (state, action) => {
          state.data = action.payload;
          state.loading = false;
          state.error = false;
          state.errorMessage = null;
        })
        .addCase(fetchDropdownThunk.rejected, (state, action) => {
          state.loading = false;
          state.error = true;
          state.errorMessage = action.payload as string;
        });

        // Dropdown Warehouse
        builder
        .addCase(fetchDropdownWarehouseThunk.pending, (state) => {
          state.loading = true;
          state.error = false;
          state.errorMessage = null;
        })
        .addCase(fetchDropdownWarehouseThunk.fulfilled, (state, action) => {
          state.data = action.payload;
          state.loading = false;
          state.error = false;
          state.errorMessage = null;
        })
        .addCase(fetchDropdownWarehouseThunk.rejected, (state, action) => {
          state.loading = false;
          state.error = true;
          state.errorMessage = action.payload as string;
        });

         // Dropdown Product
         builder
         .addCase(fetchDropdownProductThunk.pending, (state) => {
           state.loading = true;
           state.error = false;
           state.errorMessage = null;
         })
         .addCase(fetchDropdownProductThunk.fulfilled, (state, action) => {
           state.data = action.payload;
           state.loading = false;
           state.error = false;
           state.errorMessage = null;
         })
         .addCase(fetchDropdownProductThunk.rejected, (state, action) => {
           state.loading = false;
           state.error = true;
           state.errorMessage = action.payload as string;
         });
    },
  });
  
  export default dropdownSlice.reducer;